import { Loading } from "@/component/Loading";
import BG_MHLOGO from "../assets/login/mh_logo.png";

export default function Index() {

  return (
    <div className="h-full bg-white flex flex-col items-center">
      <img className="w-49.5 mt-23 mb-5 select-none" draggable={false} src={BG_MHLOGO}></img>
      <span className="text-#999999 text-size-3.5 mb-30 select-none">AI会议记录</span>
      <Loading />
    </div>
  );
}
